import React from 'react';

interface TypographyProps {
  children: React.ReactNode;
}

export const Header = (props: TypographyProps) => {
  return (
    <div className="mt-10 min-w-0 flex-1">
      <h1 className="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl">
        {props.children}
      </h1>
    </div>
  );
};

export const Header2Xl = (props: TypographyProps) => {
  return (
    <div className="min-w-0 flex-1">
      <h2 className="text-xl font-bold leading-7 text-gray-900 sm:truncate sm:text-2xl">
        {props.children}
      </h2>
    </div>
  );
};

export const Header2 = (props: TypographyProps) => {
  return (
    <div className="min-w-0 flex-1">
      <h2 className="text-lg font-bold leading-7 text-gray-900 sm:truncate sm:text-xl">
        {props.children}
      </h2>
    </div>
  );
};

export const GradientText = (props: TypographyProps) => {
  return (
    <span className="bg-gradient-to-r from-sky-500 to-blue-600 bg-clip-text text-transparent">
      {props.children}
    </span>
  );
};

export const Paragraph = (props: TypographyProps) => {
  return <p className="text-sm text-gray-700">{props.children}</p>;
};
